<div mat-dialog-title>
  {{ 'Add_Roles' | translate }}
  <div class="spacer"></div>
  <mat-icon mat-dialog-close>close</mat-icon>
</div>
<mat-dialog-content class="container">
  <div>
    <app-user-apps-details
      (isInternalCheck)="isInternalUpdate($event)"
    ></app-user-apps-details>
  </div>
  <div>
    <app-apps-details [app]="data?.app" [isInternal]="data?.isInternal">
    </app-apps-details>
  </div>
</mat-dialog-content>
